
export { ReportModule } from './report.module';
export { ReportComponent } from './report.component';